export default __webpack_public_path__ + "static/media/FOTO-07.81596a82.jpg";